import { QueryKeys } from '@enums/queryKeys';
import { ApiRoute } from '@routes/apiRoutes';
import { httpService } from '@services/httpService';
import { useQuery } from '@tanstack/react-query';
import { CompanyThemeModel } from '@models/theme/companyThemeModel';
import { QueryCacheConstants } from '@constants/queryCacheConstants';

export const useCompanyThemeApi = (companyId: string) => {
  const getCompanyTheme = async () => {
    return await httpService.get<CompanyThemeModel>(
      `${ApiRoute.CompanyTheme}?companyId=${companyId}`
    );
  };

  return useQuery({
    queryKey: [QueryKeys.COMPANY_THEME, companyId],
    queryFn: () => getCompanyTheme(),
    enabled: !!companyId,
    staleTime: QueryCacheConstants.LONG_STALE_TIME,
    gcTime: QueryCacheConstants.LONG_GC_TIME,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
